import React, { Component } from 'react';
import { observer, inject } from 'mobx-react';
import { Row, Col, Button } from 'antd';
import Format from '../../utils/format';

@inject(
  'templateStore',
  'webSettingStore',
  'homeSpaOfferStore'
)
@observer
class HomeSpaOffer extends Component {
  constructor(props) {
    super(props)
    this.state = {
    }
  }

  componentDidMount() {
  }

  itemClick = (id) => {
    this.props.history.push(`/spa-offer/${id}`);
  }

  render() {
    const { activeTemplate } = this.props.templateStore;

    const { data: webSettting } = this.props.webSettingStore;

    const { spaOffers } = this.props.homeSpaOfferStore;

    const lang = window.localStorage.getItem('lang') || 'en';

    return (
      <>
        {
          activeTemplate
            ?
            <>
              {
                webSettting
                  ?
                  <>
                    {
                      spaOffers.length > 0
                        ?
                        <>
                          <Row>
                            <Col>
                              {/* Title */}
                              <Row>
                                <Col
                                  span={24}
                                  className='stm-text-align-center stm-padding-top-16 stm-padding-bottom-16'
                                  style={{
                                    fontFamily: activeTemplate.templateSetting.header.fontFamily,
                                    color: activeTemplate.templateSetting.text.color,
                                    fontSize: activeTemplate.templateSetting.header.fontSize,
                                    lineHeight: `${activeTemplate.templateSetting.header.fontSize + 2}px`
                                  }}
                                >
                                  <span>{webSettting.spaOfferText}</span>
                                </Col>
                              </Row>

                              {/* List */}
                              <>
                                {
                                  spaOffers.map(item => {
                                    let titleText = item.title;
                                    let briefDescText = item.briefDesc;

                                    if (item.titleLang) {
                                      titleText =
                                        lang === 'zh' ? item.titleLang.chinese :
                                          (lang === 'zh-Hant' ? item.titleLang.chineseTraditional :
                                            (lang === 'th' ? item.titleLang.thai :
                                              (lang === 'ja' ? item.titleLang.japanese :
                                                (lang === 'ja' ? item.titleLang.vietnamese : item.title))));
                                    }

                                    if (item.briefDescLang) {
                                      briefDescText =
                                        lang === 'zh' ? item.briefDescLang.chinese :
                                          (lang === 'zh-Hant' ? item.briefDescLang.chineseTraditional :
                                            (lang === 'th' ? item.briefDescLang.thai :
                                              (lang === 'ja' ? item.briefDescLang.japanese :
                                                (lang === 'ja' ? item.briefDescLang.vietnamese : item.briefDesc))));
                                    }

                                    if (titleText === '') {
                                      titleText = item.title;
                                    }

                                    if (briefDescText === '') {
                                      briefDescText = item.briefDesc;
                                    }

                                    let firstImageUrl = '';
                                    try {
                                      let images = JSON.parse(item.imageUrl);
                                      firstImageUrl = images[0].url;
                                    } catch {
                                      firstImageUrl = item.imageUrl;
                                    }

                                    return (
                                      <Row key={item.spaOfferId}>
                                        <Col span={1} />
                                        <Col
                                          span={22}
                                          className='stm-border-radius-4 stm-margin-bottom-10'
                                          onClick={() => this.itemClick(item.spaOfferId)}
                                          style={{
                                            fontFamily: activeTemplate.templateSetting.header.fontFamily,
                                            background: activeTemplate.templateSetting.header.backgroundColor,
                                            color: activeTemplate.templateSetting.header.color
                                          }}
                                        >
                                          <Row>
                                            <Col span={24}>
                                              <img
                                                src={firstImageUrl}
                                                alt={titleText}
                                                className='stm-width-100-percent stm-height-auto stm-display-block' />
                                            </Col>
                                          </Row>
                                          <>
                                            {
                                              item.showBannerOnly
                                                ?
                                                null
                                                :
                                                <>
                                                  <Row className='stm-padding-16'>
                                                    <Col
                                                      span={24} className='stm-margin-bottom-8'
                                                      style={{
                                                        fontSize: activeTemplate.templateSetting.header.fontSize,
                                                        lineHeight: `${activeTemplate.templateSetting.header.fontSize + 2}px`
                                                      }}
                                                    >
                                                      <span>{titleText}</span>
                                                    </Col>
                                                    <Col
                                                      span={24}
                                                      className='stm-margin-bottom-8'
                                                      style={{
                                                        fontSize: activeTemplate.templateSetting.text.fontSize,
                                                        lineHeight: `${activeTemplate.templateSetting.text.fontSize + 4}px`
                                                      }}
                                                    >
                                                      <span>{briefDescText}</span>
                                                    </Col>
                                                    <Col
                                                      span={24}
                                                      className='stm-margin-bottom-24'
                                                      style={{
                                                        fontSize: activeTemplate.templateSetting.text.fontSize,
                                                        lineHeight: `${activeTemplate.templateSetting.text.fontSize + 4}px`
                                                      }}
                                                    >
                                                      <span>{webSettting ? webSettting.currencyCode : ''} {Format.Currency(item.price)}</span>
                                                    </Col>
                                                    <Col span={24} className='stm-text-align-right'>
                                                      <Button
                                                        style={{
                                                          fontFamily: activeTemplate.templateSetting.header.fontFamily,
                                                          background: activeTemplate.templateSetting.header.color,
                                                          color: activeTemplate.templateSetting.header.backgroundColor,
                                                          fontSize: activeTemplate.templateSetting.header.fontSize,
                                                          lineHeight: `${activeTemplate.templateSetting.header.fontSize}px`
                                                        }}
                                                      >{webSettting.detailText}</Button>
                                                    </Col>
                                                  </Row>
                                                </>
                                            }
                                          </>
                                        </Col>
                                        <Col span={1} />
                                      </Row>
                                    )
                                  })}
                              </>
                            </Col>
                          </Row>
                        </>
                        :
                        null
                    }
                  </>
                  :
                  null
              }
            </>
            :
            null
        }
      </>
    )
  }
}

export default (HomeSpaOffer)